import React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { appHeightChanged } from '../../actions/app-actions'
import Login from './Login'

class LoginState extends React.Component {
    constructor() {
        super();


    }
    componentDidMount() {
        const { actions,  iframeId } = this.props
        if (window.parent != window) actions.appHeightChanged(iframeId, false);
     
      
    }


    componentWillUnmount() {
        const { actions, iframeId } = this.props;
        if (window.parent != window) actions.appHeightChanged(iframeId, false, true, false);
        else sessionStorage.setItem("scroll-position", window.scrollY);
    }

   

    render() {
        const { iframeId, orgID } = this.props
        const search = window.location.search;
        const paramss = new URLSearchParams(search);
        let org = paramss.get('org')    
      
        return (
            <Login iframeId={iframeId} orgID={org} />
        )
    }
}

const mapStateToProps = (state, ownProps) => {
  
  
    return {
        iframeId: state.app.iframeId,
        orgID: state.organizer.id
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        actions: bindActionCreators(Object.assign({}, { appHeightChanged,  }), dispatch)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(LoginState)